import { render, staticRenderFns } from "./DsnTabs.vue?vue&type=template&id=1258288a&scoped=true&"
import script from "./DsnTabs.vue?vue&type=script&lang=js&"
export * from "./DsnTabs.vue?vue&type=script&lang=js&"
import style0 from "./DsnTabs.vue?vue&type=style&index=0&id=1258288a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1258288a",
  null
  
)

export default component.exports